var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-screenshots-container"},[_c('div',{staticClass:"app-screenshots"},_vm._l((_vm.screenshots),function(screenshot,index){return _c('app-screenshot',{key:`app_screenshot_${index}`,attrs:{"url":screenshot}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }